
import React from 'react';

export const About: React.FC = () => {
  return (
    <section id="about" className="py-16 sm:py-20 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-4 max-w-full">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4 sm:mb-6 break-words">
            私たちについて
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed break-words">
            訪問介護のんな福島は、2023年10月にオープンした新しい事業所です。
            ご利用者様お一人おひとりに寄り添った質の高いサービスを提供いたします。
          </p>
        </div>

        {/* 管理者からのメッセージ */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-12 sm:mb-16">
          <div className="flex items-center justify-center order-2 lg:order-1">
            <img 
              src="https://public.readdy.ai/ai/img_res/865385ca-2253-4ed7-80c5-09e7dda791b3.png" 
              alt="管理者 山口尚美" 
              className="w-64 h-64 sm:w-80 sm:h-80 object-cover rounded-full shadow-xl max-w-full"
            />
          </div>
          <div className="order-1 lg:order-2 min-w-0">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 text-center lg:text-left break-words">
              管理者からのメッセージ
            </h3>
            <div className="bg-white p-6 sm:p-8 rounded-lg">
              <h4 className="text-xl sm:text-2xl font-semibold text-pink-600 mb-3 sm:mb-4 text-center lg:text-left break-words">
                管理者 山口 尚美
              </h4>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-3 sm:mb-4 break-all">
                友人より「あなたは介護の仕事にむいているから一緒にやってみない？」と誘われていました。とても私にはできる仕事ではないと断り続けておりましたが、たくさんの仕事を経験して何か他のことにも挑戦してみたいと考えるようになり、資格なし、未経験でもOKの募集を見つけ応募したのがきっかけです。
              </p>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed break-all">
                右も左も理解できなかった私に先輩が親切に教えてくれたこと、そして利用者への感謝していただき嬉しかったこと。とてもやりがいがある仕事だと思いました。
                これからは私が管理者として、介護の楽しさを伝え、職員と一緒により良い介護を提供していきたいです。
              </p>
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md text-center">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <i className="ri-heart-fill text-pink-600 text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">心に寄り添う</h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed break-words">
              ご利用者様お一人おひとりの想いに寄り添い、
              その人らしい生活をサポートいたします。
            </p>
          </div>

          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md text-center">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <i className="ri-shield-check-fill text-pink-600 text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">安心・安全</h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed break-words">
              経験豊富なスタッフが、
              安心・安全なサービスを提供し、
              笑円をお届けします。
            </p>
          </div>

          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md text-center sm:col-span-2 lg:col-span-1">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <i className="ri-team-fill text-pink-600 text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">チーム一丸</h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed break-words">
              スタッフ一同がチーム一丸となって、
              質の高いサービスを提供いたします。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
